import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Header.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

const Header = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useTranslation();


  useEffect(() => {
    const handleScroll = () => {
      // Add background to header when scrolled
      setIsScrolled(window.scrollY > 50);

      // Update active section
      const sections = ['home', 'services', 'about', 'portfolio', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

 const navLinks = [
    { id: 'home', label: t('nav.home') },
    { id: 'services', label: t('nav.services') },
    { id: 'about', label: t('nav.about') },
    { id: 'portfolio', label: t('nav.portfolio') },
    { id: 'contact', label: t('nav.contact') },
  ];

  return (
    <motion.nav
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="nav-container">
        {/* Logo */}
        <motion.a
          href="#home"
          className="logo"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setIsMenuOpen(false)}
        >
          <img 
            src="https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768336636/logo_final_rouge_png_muyxcw.png


" 
            alt="Orvin Creative Agency" 
            className="logo-image"
          />
        </motion.a>

  {/* Navigation Links */}
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <motion.li key={link.id} whileHover={{ scale: 1.1 }}>
              <a
                href={`#${link.id}`}
                className={activeSection === link.id ? 'active' : ''}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </a>
            </motion.li>
          ))}
        </ul>
{/* <LanguageSwitcher /> */}
{/* // Use the mini version in header */}
<LanguageSwitcher mini={true} />
        {/* CTA Button */}
        <motion.a
          href="#contact"
          className="cta-button"
          whileHover={{ scale: 1.05, boxShadow: '0 10px 40px rgba(255, 76, 76, 0.4)' }}
          whileTap={{ scale: 0.95 }}
        >
          {t('nav.getStarted', { defaultValue: 'Get Started' })}
        </motion.a>

        {/* Mobile Menu Toggle */}
        <div
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </motion.nav>
  );
};

export default Header;
